import { BodyShapeOptionIdType } from '@/pages/Onboarding/options/BodyShape/types';
import { HairColorOptionIdType } from '@/pages/Onboarding/options/HairColor/types';

export const supportedSexyBodyShapes: BodyShapeOptionIdType[] = [
  'regular',
  'skinny',
];
export const supportedSexyHairColors: HairColorOptionIdType[] = ['brunette'];
